
import {Mixins, Prop} from 'vue-property-decorator'
import Component from 'vue-class-component'
import UsersMixin from '@/components/Users/UsersMixin'
import GreenButton from '@/components/Atomic/GreenButton.vue'
import RedButton from '@/components/Atomic/RedButton.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'
import UserService from '@/services/UserService'
import {GenericUser} from '@/models/user'
import GridHeader from '@/models/gridHeader'
import {Dictionary} from 'vue-router/types/router'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ActionTypes from '@/models/constants/ActionTypes'
import RefStatus from '@/models/constants/RefStatus'

@Component({
  components: {
    CardTitle,
    GreenButton,
    RedButton,
    ProgressLinear,
  },
})
export default class UserHistory extends Mixins(UsersMixin) {
  @Prop() private buttonActivation: boolean
  private isLoading: boolean = false
  private userData: Dictionary<any> = {}
  private userHistory: Dictionary<any> = {}
  private userEvent: Dictionary<any> = {}
  private groupHeaders: GridHeader[] = []
  private tab: any = null
  private user: GenericUser
  private affectations: Dictionary<string>[] = []

  constructor() {
    super()
  }

  public async show(user: GenericUser) {
    this.user = user
    this.dialog = true
    await this.fetchUserHistory()
  }

  private mounted() {
    this.generateGroupHeaders()
  }

  private async fetchUserHistory() {
    this.isLoading = true
    this.userData = await UserService.getUserHistory(this.user.ad_personne_id)
    this.userHistory = this.userData.history
    this.userEvent = this.userData.events
    this.parse_users_affectations()
    this.isLoading = false
  }

  private parse_users_affectations() {
    this.affectations = []
    var last_affectation = ""
    for (var key in this.userHistory) {
      if (this.userHistory[key].attributes.source) {
        if (this.userHistory[key].attributes.source.new_value != last_affectation) {
          var affectation = {}
          last_affectation = this.userHistory[key].attributes.source.new_value
          affectation["source"] = this.userHistory[key].attributes.source.new_value
          affectation["date"] = this.userHistory[key].date_time
          affectation["action"] = this.userHistory[key].action
          this.affectations.push(affectation)
        }
      }
    }
  }

  private generateGroupHeaders() {
    this.groupHeaders.push(
      new GridHeader(
        this.$t('HeaderGroup').toString(),
        'name',
        'left',
        false,
        50,
      ),
    )
    this.groupHeaders.push(
        new GridHeader(
            this.$t('HeaderRepository').toString(),
            'repository',
            'center',
            false,
            25,
        ),
    )
    this.groupHeaders.push(
      new GridHeader(
        this.$t('HeaderLdap').toString(),
        'ldap',
        'center',
        false,
        25,
      ),
    )
  }

  private actionColorOrIconForEvent(action: string, type: string) {

    switch (action) {
      case ActionTypes.ChangeEmail:
        if (type === 'icon') {
          return 'mdi-email-edit-outline'
        } else {
          return 'blue'
        }
      case ActionTypes.ChangePassword:
        if (type === 'icon') {
          return 'mdi-lock-reset'
        } else {
          return 'blue'
        }
      case ActionTypes.ResetPassword:
        if (type === 'icon') {
          return 'mdi-lock-reset'
        } else {
          return 'blue'
        }
      case ActionTypes.CreateTemporaryAccount:
        if (type === 'icon') {
          return 'mdi-plus'
        } else {
          return 'green'
        }
      case ActionTypes.ModifyTemporaryAccount:
        if (type === 'icon') {
          return 'mdi-pencil'
        } else {
          return 'blue'
        }
      case ActionTypes.DeleteTemporaryAccount:
        if (type === 'icon') {
          return 'mdi-close'
        } else {
          return 'red'
        }
      case ActionTypes.EnableTemporaryAccount:
        if (type === 'icon') {
          return 'mdi-check'
        } else {
          return 'green'
        }
      case ActionTypes.DisableTemporaryAccount:
        if (type === 'icon') {
          return 'mdi-cancel'
        } else {
          return 'red'
        }
      case ActionTypes.ExtendDateTemporaryAccount:
        if (type === 'icon') {
          return 'mdi-clock-outline'
        } else {
          return 'blue'
        }
      case ActionTypes.StartMireoMission:
        if (type === 'icon') {
          return'mdi-play-circle-outline'
        } else {
          return 'green'
        }
      case ActionTypes.EndMireoMission:
        if (type === 'icon') {
          return 'mdi-stop-circle-outline'
        } else {
          return 'red'
        }
      case ActionTypes.ExtendDateMireoAccount:
        if (type === 'icon') {
          return 'mdi-calendar'
        } else {
          return 'blue'
        }
      case ActionTypes.RecoverPassword:
        if (type === 'icon') {
          return 'mdi-lock-reset'
        } else {
          return 'blue'
        }
      case ActionTypes.RecoverUsername:
        if (type === 'icon') {
          return 'mdi-lock-reset'
        } else {
          return 'blue'
        }
      case ActionTypes.ChangeWifiStatus:
        if (type === 'icon') {
          return 'mdi-wifi'
        } else {
          return 'blue'
        }
      case ActionTypes.ModifyService:
        if (type === 'icon') {
          return 'mdi-cloud-tags'
        } else {
          return 'blue'
        }
      case ActionTypes.AssignService:
        if (type === 'icon') {
          return 'mdi-cloud-tags'
        } else {
          return 'blue'
        }
      case ActionTypes.RemoveService:
        if (type === 'icon') {
          return 'mdi-cloud-tags'
        } else {
          return 'red'
        }
      case ActionTypes.LdapService:
        if (type === 'icon') {
          return 'mdi-alert-circle-outline'
        } else {
          return 'red'
        }
      case ActionTypes.DataService:
        if (type === 'icon') {
          return 'mdi-alert-circle-outline'
        } else {
          return 'red'
        }
      case ActionTypes.CreateExtra:
        if (type === 'icon') {
          return 'mdi-plus'
        } else {
          return 'green'
        }
      case ActionTypes.ModifyExtra:
        if (type === 'icon') {
          return 'mdi-pencil'
        } else {
          return 'blue'
        }
      case ActionTypes.DeleteExtra:
        if (type === 'icon') {
          return 'mdi-close'
        } else {
          return 'red'
        }
      case ActionTypes.DisableStudent:
        if (type === 'icon') {
          return 'mdi-cancel'
        }
        else {
          return 'red'
        }
      case ActionTypes.EnableStudent:
        if (type === 'icon') {
          return 'mdi-check'
        }
        else {
          return 'green'
        }
      case ActionTypes.GenerateActivationKey:
        if (type === 'icon') {
          return 'mdi-key-change'
        }
        else {
          return 'blue'
        }
    }
  }

  private actionColorOrIcon(action: string, type: string) {
    switch (action) {
      case RefStatus.Added:
        if (type === 'icon') {
          return 'mdi-plus'
        } else {
          return 'green'
        }
      case RefStatus.Enabled:
        if (type === 'icon') {
          return 'mdi-check'
        } else {
          return 'green'
        }
      case RefStatus.Disabled:
        if (type === 'icon') {
          return 'mdi-cancel'
        } else {
          return 'red'
        }
      case RefStatus.Archived:
        if (type === 'icon') {
          return 'mdi-archive'
        } else {
          return 'grey'
        }
      case RefStatus.InitialState:
        if (type === 'icon') {
          return 'mdi-account-circle'
        } else {
          return 'green'
        }
      case RefStatus.Modified:
        if (type === 'icon') {
          return 'mdi-pencil'
        } else {
          return 'blue'
        }
      case RefStatus.Extended:
        if (type === 'icon') {
          return 'mdi-clock-outline'
        } else {
          return 'orange'
        }
      case RefStatus.Deleted:
        if (type === 'icon') {
          return 'mdi-close'
        } else {
          return 'red'
        }
    }
  }
}
